import { useEffect, useState } from 'react';

// Types
import { DisplayCheckResult } from '@/types';

type DisplayChecker = (date: string) => DisplayCheckResult;

export const useTimedDisplay = (
  date: string,
  displayChecker: DisplayChecker,
): boolean => {
  const [isDisplay, setIsDisplay] = useState(false);

  useEffect(() => {
    if (!date) return;

    const { isDisplay, timeoutMs } = displayChecker(date);

    setIsDisplay(isDisplay);

    const isValidTimeout = timeoutMs !== null && timeoutMs > 0;

    if (isDisplay && isValidTimeout) {
      const timer = setTimeout(() => {
        setIsDisplay(false);
      }, timeoutMs);

      return () => clearTimeout(timer);
    }
  }, [date, displayChecker]);

  return isDisplay;
};
